import { Card } from 'primereact/card';
import React, { ReactNode } from "react";
import { useResponsive } from "../../../responsive/ResponsiveProvider";
import {
  appAccentPanelStyle,
  appMutedTextStyle,
  appSectionCardStyle,
} from "../../../components/general/uiSurfaceStyles";

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
  const { isNarrow } = useResponsive();

  const titleTemplate = (
    <div className="mb-3">
      <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#0f172a" }}>{title}</div>
      {subtitle ? <div className="mt-2" style={appMutedTextStyle}>{subtitle}</div> : null}
    </div>
  );
  return (
    <div className="grid justify-content-center align-items-center flex-wrap flex-column" style={{ minHeight: "fit-content", marginTop: isNarrow ? '20px' : '50px', padding: "1rem" }} >
      <div style={{ width: "100%", maxWidth: "620px" }}>
        <Card title={titleTemplate} className='col' style={appSectionCardStyle}>{children}</Card>
      </div>
    </div>
  );
};

export default AuthLayout;
